import { Instagram, LinkedIn } from "@mui/icons-material";
import { Box, IconButton, Link, Typography } from "@mui/joy";
import { useNavigate } from "react-router";

import { BrandWithIcon } from "~/common/components";
import { RoutePaths } from "~/common/constants/route-paths";

export const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        py: { xs: 4, sm: 6 },
        px: { xs: 2, sm: 3, md: 4, lg: 6 },
        borderTop: "1px solid",
        borderColor: "divider",
      }}
    >
      <Box
        sx={{
          maxWidth: { lg: 1200, xl: 1400 },
          mx: "auto",
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "center", sm: "flex-start" },
          justifyContent: "space-between",
          gap: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: { xs: "center", sm: "flex-start" },
            gap: 1,
          }}
        >
          <BrandWithIcon iconSize={24} fontSize="sm" />
          <Typography level="body-sm" textColor="text.tertiary">
            © {currentYear} Brandly. Усі права захищено.
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 0.25,
              mt: 0.5,
            }}
          >
            <Typography level="body-xs" textColor="text.tertiary">
              ТОВ &quot;АЙПІ ЛІГАЛТЕХ&quot;
            </Typography>
            <Typography level="body-xs" textColor="text.tertiary">
              ЄДРПОУ 46011998
            </Typography>
            <Link
              level="body-xs"
              color="neutral"
              href="tel:+380688055852"
              sx={{ "&:hover": { color: "primary.500" } }}
            >
              +380 68 805 5852
            </Link>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: 1.5,
            justifyContent: "center",
          }}
        >
          <IconButton
            component="a"
            href="https://www.instagram.com/brandly_tm/"
            target="_blank"
            rel="noopener noreferrer"
            variant="plain"
            color="neutral"
            size="sm"
            sx={{ "&:hover": { color: "primary.500" } }}
          >
            <Instagram />
          </IconButton>
          <IconButton
            component="a"
            href="https://www.linkedin.com/company/brandly-ua/"
            target="_blank"
            rel="noopener noreferrer"
            variant="plain"
            color="neutral"
            size="sm"
            sx={{ "&:hover": { color: "primary.500" } }}
          >
            <LinkedIn />
          </IconButton>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            alignItems: { xs: "center", sm: "flex-end" },
          }}
        >
          <Link
            level="body-sm"
            color="neutral"
            href="https://docs.google.com/document/d/16J2S6haSJ7vS9lMwZ2M8Nv3lLv_kFGLW/edit?usp=sharing&ouid=107759714880134026348&rtpof=true&sd=true"
            target="_blank"
            sx={{ "&:hover": { color: "primary.500" } }}
          >
            Політика конфіденційності
          </Link>
          <Link
            level="body-sm"
            color="neutral"
            href="https://docs.google.com/document/d/1hzJzV7UjBoqPjU3DnslmKH51HMyhnPGiNb0kxetiPkI/edit?usp=sharing"
            target="_blank"
            sx={{ "&:hover": { color: "primary.500" } }}
          >
            Оферта
          </Link>
          <Link
            level="body-sm"
            color="neutral"
            href={RoutePaths.ABOUT_US}
            sx={{ "&:hover": { color: "primary.500" } }}
            onClick={(e) => {
              e.preventDefault();
              void navigate(`${RoutePaths.ABOUT_US}?section=contact`);
            }}
          >
            Контакти
          </Link>
        </Box>
      </Box>
    </Box>
  );
};
